module.exports = __webpack_public_path__ + "img/6.6ced2967.png";